import { useHistory, Link } from "react-router-dom";

const ConfirmationSent = () => {

    const history = useHistory();
    const queryParams = new URLSearchParams(history.location.search);
    const userEmail = queryParams.get('email')

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ "min-height": "calc(100vh - 100px)" }}>
            <div className="container-fluid">
                <div className="alert register-alert">
                    <h3>Confirmation email sent successfully</h3>
                    <p>
                        A new confirmation email was sent to your email <b>{userEmail}</b>.
                        Click on the link in the email to activate your account
                    </p>
                    <Link to={'/'}><button className="btn-black">Return to Home</button></Link>
                </div>
            </div>
        </div>
    )
}

export { ConfirmationSent }